import { useFlags } from 'src/feature-flags/FlagsHook';
import { useAppContainerContext } from '../AppContainerContext';
import { DEFAULT_THINKING_EFFORT, ThinkingEffort } from './thinkingEffort';

/**
 * The thinking effort for the conversation on screen. Maximum is the default, but a level the
 * adviser chooses stays for the rest of that conversation: snapping back after every message made
 * them set it again each time. A new conversation starts at the default.
 */
export function useConversationThinkingEffort() {
  const { conversationId, chosenThinkingEfforts, chooseThinkingEffort } = useAppContainerContext();
  const { flagEnabledSiestaThinkingEffort } = useFlags();
  const enabled = flagEnabledSiestaThinkingEffort === true;
  const chosen: ThinkingEffort | undefined = chosenThinkingEfforts[conversationId];
  const thinkingEffort = chosen ?? DEFAULT_THINKING_EFFORT;

  // Sending from a displaced chat starts a new conversation, so a chosen level goes with the
  // message into it rather than snapping back at that moment. The default is never carried over as
  // if it had been chosen.
  const carryChosenEffortInto = (newConversationId: string) => {
    if (enabled && chosen !== undefined && newConversationId !== conversationId) {
      chooseThinkingEffort(newConversationId, chosen);
    }
  };

  return {
    enabled,
    thinkingEffort,
    // What the pill shows is what is sent, and nothing is named while the feature is off.
    effortToSend: enabled ? thinkingEffort : undefined,
    chooseThinkingEffort: (effort: ThinkingEffort) => chooseThinkingEffort(conversationId, effort),
    carryChosenEffortInto,
  };
}
